import { combineReducers } from 'redux';
import {
    REQUEST_COMPANIES,
    RECEIVE_COMPANIES,
    COMPANIES_PAGE_COUNT,
    SET_COUNTRY_FILTER,
    CLEAR_COUNTRY_FILTER,
    CLEAR_SEGMENT_FILTER,
    SET_SEGMENT_FILTER,
    RECEIVE_SEGMENTS,
    REQUEST_SEGMENTS,
    SET_SEARCH,
    CLEAR_SEARCH,
} from './actionTypes';
import { mergeObjectArrays } from '../../configureStore';

const initialFilterState = { country: [], segment: [] };

const items = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_COMPANIES:
            if (action.page === 1) return action.companies;
            else return mergeObjectArrays(action.companies, state);
        default:
            return state;
    }
};

const hasMore = (state = false, action = {}) => {
    switch (action.type) {
        case REQUEST_COMPANIES:
            return true;
        case RECEIVE_COMPANIES:
            return action.companies.length >= COMPANIES_PAGE_COUNT;
        default:
            return state;
    }
};

const isFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_COMPANIES:
        case REQUEST_SEGMENTS:
            return true;
        case RECEIVE_COMPANIES:
        case RECEIVE_SEGMENTS:
            return false;
        default:
            return state;
    }
};

const filter = (state = initialFilterState, action) => {
    switch (action.type) {
        case SET_COUNTRY_FILTER:
            return { ...state, country: action.country };
        case CLEAR_COUNTRY_FILTER:
            return { ...state, country: [] };
        case CLEAR_SEGMENT_FILTER:
            return { ...state, segment: [] };
        case SET_SEGMENT_FILTER:
            return { ...state, segment: action.segment };
        default:
            return state;
    }
};

const segments = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_SEGMENTS:
            return action.segments;
        default:
            return state;
    }
};

const search = (state = '', action) => {
    switch (action.type) {
        case SET_SEARCH:
            return action.search;
        case CLEAR_SEARCH:
            return '';
        default:
            return state;
    }
};

export const companiesReducer = combineReducers({
    items,
    isFetching,
    hasMore,
    filter,
    segments,
    search,
});
